import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ClipboardIcon, RepeatIcon, CheckCircleIcon } from 'lucide-react';
export const Process = () => {
  const processSteps = [{
    title: 'Choose a plan',
    description: 'Pick a subscription that matches your stage and budget.',
    icon: <ClipboardIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-714" />,
    number: 1
  }, {
    title: 'Submit ideas & data',
    description: "Describe the product challenges you're facing. We'll use AI to uncover insights and prototype solutions.",
    icon: <RepeatIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-715" />,
    number: 2
  }, {
    title: 'Get results fast',
    description: 'Your PM delivers roadmaps, prototypes and AI‑driven recommendations in days, not months.',
    icon: <CheckCircleIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-716" />,
    number: 3
  }];
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="process" className="py-20 bg-white relative overflow-hidden" data-id="element-717">
      <div className="absolute top-0 left-0 w-64 h-64 bg-purple-50 rounded-full opacity-60 -ml-32 -mt-32" data-id="element-718"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-50 rounded-full opacity-50 -mr-40 -mb-40" data-id="element-719"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-720">
        <div className="text-center mb-16" data-id="element-721">
          <p className="text-primary font-medium mb-2" data-id="element-722">OUR PROCESS</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-723">
            How It Works
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-724">
            Our simple three-step process gets you from subscription to
            execution in no time. Our PMs use AI‑powered research tools and
            quick prototypes to validate decisions.
          </p>
        </div>
        {/* Process Steps - Desktop has horizontal layout with connecting lines */}
        <div className="hidden md:block max-w-5xl mx-auto relative" data-id="element-725">
          {/* Connecting lines */}
          <div className="absolute top-1/2 left-[calc(16.67%+32px)] right-[calc(16.67%+32px)] h-0.5 bg-gray-200 -mt-0.5 z-0" data-id="element-726"></div>
          <div className="absolute top-1/2 left-[calc(50%-32px)] w-16 h-0.5 bg-gray-200 -mt-0.5 z-0 transform rotate-45" data-id="element-727"></div>
          <div className="absolute top-1/2 right-[calc(50%-32px)] w-16 h-0.5 bg-gray-200 -mt-0.5 z-0 transform -rotate-45" data-id="element-728"></div>
          <div className="grid grid-cols-3 gap-8" data-id="element-729">
            {processSteps.map((step, index) => <div key={index} className="relative" data-id="element-730">
                <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-731">
                  {step.number}
                </div>
                <Card className="text-center group relative z-10" data-id="element-732">
                  <div className="mb-6 flex justify-center" data-id="element-733">{step.icon}</div>
                  <h3 className="text-xl font-bold mb-2 text-black" data-id="element-734">
                    {step.title}
                  </h3>
                  <p className="text-text-secondary" data-id="element-735">{step.description}</p>
                </Card>
              </div>)}
          </div>
        </div>
        {/* Process Steps - Mobile has vertical layout with generous spacing */}
        <div className="md:hidden space-y-12 max-w-sm mx-auto" data-id="element-736">
          {processSteps.map((step, index) => <div key={index} className="relative" data-id="element-737">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-738">
                {step.number}
              </div>
              <Card className="text-center group" data-id="element-739">
                <div className="mb-6 flex justify-center" data-id="element-740">{step.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-black" data-id="element-741">
                  {step.title}
                </h3>
                <p className="text-text-secondary" data-id="element-742">{step.description}</p>
              </Card>
              {index < processSteps.length - 1 && <div className="h-8 w-0.5 bg-gray-200 mx-auto mt-4" data-id="element-743"></div>}
            </div>)}
        </div>
        {/* Secondary CTA below the fold */}
        <div className="mt-16 text-center" data-id="element-744">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4 focus:ring-2 focus:ring-primary focus:ring-offset-2" data-id="element-745">
            Speak with a Senior PM
          </Button>
        </div>
      </div>
    </section>;
};